import AppLayout from '@/layouts/AppLayout.vue'
import HomeView from '@/views/home/HomeView.vue'

const routes = [
  {
    path: '/',
    component: AppLayout,
    redirect: { path: '/home' },
    meta: { title: '首页' },
    children: [
      {
        path: 'home',
        component: () => import('@/views/home/LayoutView.vue'),
        meta: { permission: false },
        children: [
          {
            path: '',
            component: HomeView
          }
        ]
      },
      {
        path: 'todoList',
        component: () => import('@/views/todoList/todoListView.vue'),
        meta: { title: '待办事项', permission: false }
      },
      {
        path: 'system',
        meta: { title: '系统管理', layout: true },
        children: [
          {
            path: 'role',
            component: () => import('@/views/system/role/LayoutView.vue'),
            meta: { title: '角色管理' },
            children: [
              {
                path: '',
                component: () => import('@/views/system/role/RoleView.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/system/role/AddView.vue'),
                meta: { title: '添加角色' }
              },
              {
                path: 'update',
                component: () => import('@/views/system/role/UpdateView.vue'),
                meta: { title: '修改角色' }
              },
              {
                path: 'look',
                component: () => import('@/views/system/role/LookView.vue'),
                meta: { title: '查看角色', permission: 'system/role' }
              }
            ]
          },
          {
            path: 'user',
            component: () => import('@/views/system/user/LayoutView.vue'),
            meta: { title: '用户管理' },
            children: [
              {
                path: '',
                component: () => import('@/views/system/user/UserView.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/system/user/AddView.vue'),
                meta: { title: '添加用户' }
              },
              {
                path: 'update',
                component: () => import('@/views/system/user/UpdateView.vue'),
                meta: { title: '修改用户' }
              }
            ]
          },
          {
            path: 'architecture',
            component: () => import('@/views/system/architecture/LayoutView.vue'),
            meta: { title: '组织架构' },
            children: [
              {
                path: '',
                component: () => import('@/views/system/architecture/ArchitectureView.vue')
              }
            ]
          },
          {
            path: 'dictionary',
            component: () => import('@/views/system/dictionary/LayoutView.vue'),
            meta: { title: '数据字典' },
            children: [
              {
                path: '',
                component: () => import('@/views/system/dictionary/DictionaryView.vue')
              }
            ]
          },
          {
            path: 'period',
            component: () => import('@/views/system/period/LayoutView.vue'),
            meta: { title: '执行周期' },
            children: [
              {
                path: '',
                component: () => import('@/views/system/period/PeriodList.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/system/period/AddView.vue'),
                meta: { title: '添加周期' }
              },
              {
                path: 'update',
                component: () => import('@/views/system/period/UpdateView.vue'),
                meta: { title: '修改周期' }
              }
            ]
          },
          {
            path: 'operation',
            component: () => import('@/views/system/operation/OperationLog.vue'),
            meta: { title: '操作日志' }
          },
          {
            path: 'setting',
            component: () => import('@/views/system/setting/SettingView.vue'),
            meta: { title: '其他设置' }
          }
        ]
      },
      {
        path: 'core',
        meta: { title: '风险分级管控', layout: true },
        children: [
          {
            path: 'map',
            component: () => import('@/views/core/map/LayoutView.vue'),
            meta: { title: '风险四色图' },
            children: [
              {
                path: '',
                component: () => import('@/views/core/map/RiskMapView.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/core/map/AddView.vue'),
                meta: { title: '添加四色图' }
              },
              {
                path: 'update',
                component: () => import('@/views/core/map/UpdateView.vue'),
                meta: { title: '修改四色图' }
              }
            ]
          },
          {
            path: 'risk',
            component: () => import('@/views/core/risk/LayoutView.vue'),
            redirect: { path: '/core/risk/risk' },
            meta: { title: '风险管理' },
            children: [
              {
                path: 'risk',
                component: () => import('@/views/core/risk/risk/LayoutView.vue'),
                meta: { title: '风险单元管理', permission: 'core/risk/risk' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/core/risk/risk/RiskView.vue')
                  },
                  {
                    path: 'estimate',
                    component: () => import('@/views/core/risk/risk/EvaluateView.vue'),
                    meta: { title: '风险评估', permission: 'core/risk/risk/eval' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/core/risk/risk/LookView.vue'),
                    meta: { title: '查看' }
                  },
                  {
                    path: 'approved',
                    component: () => import('@/views/core/risk/risk/ApprovedView.vue'),
                    meta: { title: '已审批' }
                  },
                  {
                    path: 'history',
                    component: () => import('@/views/core/risk/risk/HistoryView.vue'),
                    meta: { title: '操作历史' }
                  },
                  {
                    path: 'set',
                    component: () => import('@/views/core/risk/risk/SetView.vue'),
                    meta: { title: '设置' }
                  }
                ]
              },
              {
                path: 'device',
                component: () => import('@/views/core/risk/device/LayoutView.vue'),
                meta: { title: '设备设施' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/core/risk/device/DeviceView.vue')
                  }
                ]
              },
              {
                path: 'job',
                component: () => import('@/views/core/risk/job/LayoutView.vue'),
                meta: { title: '作业活动' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/core/risk/job/JobView.vue')
                  }
                ]
              },
              {
                path: 'std',
                component: () => import('@/views/core/risk/std/LayoutView.vue'),
                meta: { title: '风险评估标准' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/core/risk/std/StandardView.vue')
                  },
                  {
                    path: 'add',
                    component: () => import('@/views/core/risk/std/AddView.vue'),
                    meta: { title: '新增' }
                  },
                  {
                    path: 'update',
                    component: () => import('@/views/core/risk/std/EditView.vue'),
                    meta: { title: '修改' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/core/risk/std/LookView.vue'),
                    meta: { title: '查看', permission: 'core/risk/std' }
                  }
                ]
              }
            ]
          },
          {
            path: 'check',
            component: () => import('@/views/core/check/LayoutView.vue'),
            redirect: { path: '/core/check/checkList' },
            meta: { title: '隐患排查' },
            children: [
              {
                path: 'checkList',
                component: () => import('@/views/core/check/checkList/LayoutView.vue'),
                meta: { title: '排查表' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/core/check/checkList/CheckList.vue')
                  },
                  {
                    path: 'add',
                    component: () => import('@/views/core/check/checkList/AddView.vue'),
                    meta: { title: '添加' }
                  },
                  {
                    path: 'update',
                    component: () => import('@/views/core/check/checkList/UpdateView.vue'),
                    meta: { title: '修改' }
                  },
                  {
                    path: 'shared',
                    component: () => import('@/views/core/check/checkList/SharedView.vue'),
                    meta: { title: '共享排查表', permission: 'core/check/checkList' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/core/check/checkList/LookView.vue'),
                    meta: { title: '查看', permission: 'core/check/checkList' }
                  }
                ]
              },
              {
                path: 'checkTask',
                component: () => import('@/views/core/check/checkTask/LayoutView.vue'),
                meta: { title: '常规排查' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/core/check/checkTask/TaskList.vue')
                  },
                  {
                    path: 'add',
                    component: () => import('@/views/core/check/checkTask/AddView.vue'),
                    meta: { title: '添加排查任务' }
                  },
                  {
                    path: 'history',
                    component: () => import('@/views/core/check/checkTask/HistoryView.vue'),
                    meta: { title: '排查历史', permission: 'core/check/checkTask' }
                  },
                  {
                    path: 'detailHistory',
                    component: () => import('@/views/core/check/checkTask/DetailHistoryView.vue'),
                    meta: { title: '详细历史', permission: 'core/check/checkTask' }
                  },
                  {
                    path: 'execute',
                    component: () => import('@/views/core/check/checkTask/ExecuteView.vue'),
                    meta: { title: '执行排查' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/core/check/checkTask/LookView.vue'),
                    meta: { title: '查看', permission: 'core/check/checkTask' }
                  }
                ]
              },
              {
                path: 'riskTask',
                component: () => import('@/views/core/check/riskTask/LayoutView.vue'),
                meta: { title: '风险评估排查', permission: 'core/check/riskTask' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/core/check/riskTask/TaskList.vue')
                  },
                  {
                    path: 'history',
                    component: () => import('@/views/core/check/riskTask/HistoryView.vue'),
                    meta: { title: '排查历史' }
                  },
                  {
                    path: 'detailHistory',
                    component: () => import('@/views/core/check/riskTask/DetailHistoryView.vue'),
                    meta: { title: '详细历史' }
                  },
                  {
                    path: 'execute',
                    component: () => import('@/views/core/check/riskTask/ExecuteView.vue'),
                    meta: { title: '执行排查' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/core/check/riskTask/LookView.vue'),
                    meta: { title: '查看' }
                  }
                ]
              }
            ]
          },
          {
            path: 'hazard',
            component: () => import('@/views/core/hazard/LayoutView.vue'),
            meta: { title: '隐患发现', permission: 'core/hazard' },
            children: [
              {
                path: '',
                component: () => import('@/views/core/hazard/HazardList.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/core/hazard/AddView.vue'),
                meta: { title: '新增隐患' }
              },
              {
                path: 'import',
                component: () => import('@/views/core/hazard/ImportView.vue'),
                meta: { title: '批量导入' }
              },
              {
                path: 'update',
                component: () => import('@/views/core/hazard/UpdateView.vue'),
                meta: { title: '修改隐患' }
              },
              {
                path: 'look',
                component: () => import('@/views/core/hazard/LookView.vue'),
                meta: { title: '查看隐患' }
              },
              {
                path: 'history',
                component: () => import('@/views/core/hazard/HistoryView.vue'),
                meta: { title: '操作历史' }
              }
            ]
          }
        ]
      },
      {
        path: 'specialEquip',
        meta: { title: '设备管理', layout: true },
        redirect: { path: '/specialEquip/equipment' },
        children: [
          {
            path: 'equipment',
            component: () => import('@/views/specialEquip/equipment/LayoutView.vue'),
            meta: { title: '特种设备', permission: 'specialEquip/equipment' },
            children: [
              {
                path: '',
                component: () => import('@/views/specialEquip/equipment/EquipList.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/specialEquip/equipment/AddView.vue'),
                meta: { title: '添加设备' }
              },
              {
                path: 'update',
                component: () => import('@/views/specialEquip/equipment/UpdateView.vue'),
                meta: { title: '修改设备' }
              },
              {
                path: 'look',
                component: () => import('@/views/specialEquip/equipment/LookView.vue'),
                meta: { title: '设备详情' }
              },
              {
                path: 'history',
                component: () => import('@/views/specialEquip/equipment/HistoryView.vue'),
                meta: { title: '操作历史' }
              }
            ]
          },
          {
            path: 'accessory',
            component: () => import('@/views/specialEquip/accessory/LayoutView.vue'),
            meta: { title: '安全附件', permission: 'specialEquip/accessory' },
            children: [
              {
                path: '',
                component: () => import('@/views/specialEquip/accessory/AccessoryList.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/specialEquip/accessory/AddView.vue'),
                meta: { title: '添加附件' }
              },
              {
                path: 'update',
                component: () => import('@/views/specialEquip/accessory/UpdateView.vue'),
                meta: { title: '修改附件' }
              },
              {
                path: 'look',
                component: () => import('@/views/specialEquip/accessory/LookView.vue'),
                meta: { title: '附件详情' }
              },
              {
                path: 'history',
                component: () => import('@/views/specialEquip/accessory/HistoryView.vue'),
                meta: { title: '操作历史' }
              }
            ]
          }
        ]
      },
      {
        path: 'specialEquip_0001',
        meta: { title: '特种设备', layout: true },
        redirect: { path: '/specialEquip_0001/equipment' },
        children: [
          {
            path: 'schedule',
            component: () => import('@/views/specialEquip_0001/schedule/LayoutView.vue'),
            meta: { title: '月调度', permission: 'specialEquip_0001/schedule' },
            children: [
              {
                path: '',
                component: () => import('@/views/specialEquip_0001/schedule/HomeView.vue')
              },
              {
                path: 'report',
                component: () => import('@/views/specialEquip_0001/schedule/ReportView.vue'),
                meta: { title: '月调度报备' }
              },
              {
                path: 'head',
                component: () => import('@/views/specialEquip_0001/schedule/HeadView.vue'),
                meta: { title: '室负责人', permission: 'specialEquip_0001/schedule/head' }
              }
            ]
          },
          {
            path: 'equipment',
            component: () => import('@/views/specialEquip_0001/equipment/LayoutView.vue'),
            meta: { title: '特种设备', permission: 'specialEquip_0001/equipment' },
            children: [
              {
                path: '',
                component: () => import('@/views/specialEquip_0001/equipment/EquipList.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/specialEquip_0001/equipment/AddView.vue'),
                meta: { title: '添加特种设备' }
              },
              {
                path: 'update',
                component: () => import('@/views/specialEquip_0001/equipment/UpdateView.vue'),
                meta: { title: '修改特种设备' }
              },
              {
                path: 'look',
                component: () => import('@/views/specialEquip_0001/equipment/LookView.vue'),
                meta: { title: '特种设备详情' }
              },
              {
                path: 'history',
                component: () => import('@/views/specialEquip_0001/equipment/HistoryView.vue'),
                meta: { title: '操作历史' }
              }
            ]
          },
          {
            path: 'valve',
            component: () => import('@/views/specialEquip_0001/valve/LayoutView.vue'),
            meta: { title: '安全阀', permission: 'specialEquip_0001/valve' },
            children: [
              {
                path: '',
                component: () => import('@/views/specialEquip_0001/valve/ValveList.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/specialEquip_0001/valve/AddView.vue'),
                meta: { title: '添加安全阀' }
              },
              {
                path: 'update',
                component: () => import('@/views/specialEquip_0001/valve/UpdateView.vue'),
                meta: { title: '修改安全阀' }
              },
              {
                path: 'look',
                component: () => import('@/views/specialEquip_0001/valve/LookView.vue'),
                meta: { title: '安全阀详情' }
              },
              {
                path: 'history',
                component: () => import('@/views/specialEquip_0001/valve/HistoryView.vue'),
                meta: { title: '操作历史' }
              }
            ]
          },
          {
            path: 'pressure',
            component: () => import('@/views/specialEquip_0001/pressure/LayoutView.vue'),
            meta: { title: '压力表', permission: 'specialEquip_0001/pressure' },
            children: [
              {
                path: '',
                component: () => import('@/views/specialEquip_0001/pressure/PressureList.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/specialEquip_0001/pressure/AddView.vue'),
                meta: { title: '添加压力表' }
              },
              {
                path: 'update',
                component: () => import('@/views/specialEquip_0001/pressure/UpdateView.vue'),
                meta: { title: '修改压力表' }
              },
              {
                path: 'look',
                component: () => import('@/views/specialEquip_0001/pressure/LookView.vue'),
                meta: { title: '压力表详情' }
              },
              {
                path: 'history',
                component: () => import('@/views/specialEquip_0001/pressure/HistoryView.vue'),
                meta: { title: '操作历史' }
              }
            ]
          },
          {
            path: 'burst',
            component: () => import('@/views/specialEquip_0001/burst/LayoutView.vue'),
            meta: { title: '爆破片', permission: 'specialEquip_0001/burst' },
            children: [
              {
                path: '',
                component: () => import('@/views/specialEquip_0001/burst/BurstList.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/specialEquip_0001/burst/AddView.vue'),
                meta: { title: '添加爆破片' }
              },
              {
                path: 'update',
                component: () => import('@/views/specialEquip_0001/burst/UpdateView.vue'),
                meta: { title: '修改爆破片' }
              },
              {
                path: 'look',
                component: () => import('@/views/specialEquip_0001/burst/LookView.vue'),
                meta: { title: '爆破片详情' }
              },
              {
                path: 'history',
                component: () => import('@/views/specialEquip_0001/burst/HistoryView.vue'),
                meta: { title: '操作历史' }
              }
            ]
          }
        ]
      },
      {
        path: 'trainExam',
        meta: { title: '培训考试', layout: true },
        children: [
          {
            path: 'onlineTrain',
            component: () => import('@/views/trainExam/onlineTrain/LayoutView.vue'),
            redirect: { path: '/trainExam/onlineTrain/regular' },
            meta: { title: '线上培训' },
            children: [
              {
                path: 'regular',
                component: () => import('@/views/trainExam/onlineTrain/regular/LayoutView.vue'),
                meta: { title: '常规培训', permission: 'trainExam/onlineTrain/regular' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/trainExam/onlineTrain/regular/TrainView.vue')
                  },
                  {
                    path: 'add',
                    component: () => import('@/views/trainExam/onlineTrain/regular/AddView.vue'),
                    meta: { title: '添加' }
                  },
                  {
                    path: 'edit',
                    component: () => import('@/views/trainExam/onlineTrain/regular/EditView.vue'),
                    meta: { title: '修改', permission: 'trainExam/onlineTrain/regular/add' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/trainExam/onlineTrain/regular/LookView.vue'),
                    meta: { title: '查看' }
                  },
                  {
                    path: 'execute',
                    component: () => import('@/views/trainExam/onlineTrain/regular/ExecuteView.vue'),
                    meta: { title: '进行学习' }
                  }
                ]
              },
              {
                path: 'risk',
                component: () => import('@/views/trainExam/onlineTrain/risk/LayoutView.vue'),
                meta: { title: '风险评估培训', permission: 'trainExam/onlineTrain/risk' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/trainExam/onlineTrain/risk/TrainView.vue')
                  },
                  {
                    path: 'look',
                    meta: { title: '详情' },
                    component: () => import('@/views/trainExam/onlineTrain/risk/LookView.vue')
                  },
                  {
                    path: 'execute',
                    meta: { title: '进行学习' },
                    component: () => import('@/views/trainExam/onlineTrain/risk/ExecuteView.vue')
                  }
                ]
              },
              {
                path: 'resource',
                component: () => import('@/views/trainExam/onlineTrain/resource/LayoutView.vue'),
                meta: { title: '培训资料' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/trainExam/onlineTrain/resource/ResourceView.vue')
                  }
                ]
              }
            ]
          },
          {
            path: 'offlineTrain',
            component: () => import('@/views/trainExam/offlineTrain/LayoutView.vue'),
            redirect: { path: '/trainExam/offlineTrain/train' },
            meta: { title: '线下培训' },
            children: [
              {
                path: 'train',
                component: () => import('@/views/trainExam/offlineTrain/train/LayoutView.vue'),
                meta: { title: '培训管理' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/trainExam/offlineTrain/train/TrainView.vue')
                  },
                  {
                    path: 'add',
                    component: () => import('@/views/trainExam/offlineTrain/train/AddView.vue'),
                    meta: { title: '添加' }
                  },
                  {
                    path: 'update',
                    component: () => import('@/views/trainExam/offlineTrain/train/UpdateView.vue'),
                    meta: { title: '修改' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/trainExam/offlineTrain/train/LookView.vue'),
                    meta: { title: '详情', permission: 'trainExam/offlineTrain/train' }
                  }
                ]
              },
              {
                path: 'eval',
                component: () => import('@/views/trainExam/offlineTrain/eval/LayoutView.vue'),
                meta: { title: '培训评价表' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/trainExam/offlineTrain/eval/EvalView.vue')
                  },
                  {
                    path: 'add',
                    component: () => import('@/views/trainExam/offlineTrain/eval/AddView.vue'),
                    meta: { title: '添加' }
                  },
                  {
                    path: 'update',
                    component: () => import('@/views/trainExam/offlineTrain/eval/UpdateView.vue'),
                    meta: { title: '修改' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/trainExam/offlineTrain/eval/LookView.vue'),
                    meta: { title: '详情', permission: 'trainExam/offlineTrain/eval' }
                  }
                ]
              }
            ]
          },
          {
            path: 'exam',
            component: () => import('@/views/trainExam/exam/LayoutView.vue'),
            redirect: { path: '/trainExam/exam/exam' },
            meta: { title: '考试管理' },
            children: [
              {
                path: 'exam',
                component: () => import('@/views/trainExam/exam/exam/LayoutView.vue'),
                meta: { title: '考试管理' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/trainExam/exam/exam/ExamView.vue')
                  },
                  {
                    path: 'add',
                    meta: { title: '添加' },
                    component: () => import('@/views/trainExam/exam/exam/AddView.vue')
                  },
                  {
                    path: 'update',
                    meta: { title: '修改' },
                    component: () => import('@/views/trainExam/exam/exam/UpdateView.vue')
                  },
                  {
                    path: 'detail',
                    meta: { title: '详情', permission: 'trainExam/exam/exam' },
                    component: () => import('@/views/trainExam/exam/exam/DetailView.vue')
                  },
                  {
                    path: 'execute',
                    meta: { title: '进行考试' },
                    component: () => import('@/views/trainExam/exam/exam/ExecuteView.vue')
                  },
                  {
                    path: 'result',
                    meta: { title: '查看结果', permission: 'trainExam/exam/exam' },
                    component: () => import('@/views/trainExam/exam/exam/ResultView.vue')
                  }
                ]
              },
              {
                path: 'paper',
                component: () => import('@/views/trainExam/exam/paper/LayoutView.vue'),
                meta: { title: '试卷管理' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/trainExam/exam/paper/PaperView.vue')
                  },
                  {
                    path: 'add',
                    meta: { title: '添加' },
                    component: () => import('@/views/trainExam/exam/paper/AddView.vue')
                  },
                  {
                    path: 'update',
                    meta: { title: '修改' },
                    component: () => import('@/views/trainExam/exam/paper/UpdateView.vue')
                  },
                  {
                    path: 'preview',
                    meta: { title: '预览', permission: 'trainExam/exam/paper' },
                    component: () => import('@/views/trainExam/exam/paper/Preview.vue')
                  }
                ]
              },
              {
                path: 'question',
                component: () => import('@/views/trainExam/exam/question/LayoutView.vue'),
                meta: { title: '试题管理' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/trainExam/exam/question/QuestionView.vue')
                  },
                  {
                    path: 'add',
                    meta: { title: '添加' },
                    component: () => import('@/views/trainExam/exam/question/AddView.vue')
                  },
                  {
                    path: 'update',
                    meta: { title: '修改' },
                    component: () => import('@/views/trainExam/exam/question/UpdateView.vue')
                  },
                  {
                    path: 'shared',
                    component: () => import('@/views/trainExam/exam/question/SharedView.vue'),
                    meta: { title: '共享试题', permission: 'trainExam/exam/question' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/trainExam/exam/question/LookView.vue'),
                    meta: { title: '查看', permission: 'trainExam/exam/question' }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'ticket',
        meta: { title: '票据办理', layout: true },
        children: [
          {
            path: 'job',
            meta: { title: '作业票' },
            component: () => import('@/views/ticket/job/LayoutView.vue'),
            redirect: { path: '/ticket/job/regular' },
            children: [
              {
                path: 'regular',
                meta: { title: '一般作业票' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/ticket/job/regular/TicketView.vue')
                  },
                  {
                    path: 'add',
                    component: () => import('@/views/ticket/job/regular/AddView.vue'),
                    meta: { title: '添加' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/ticket/job/regular/LookView.vue'),
                    meta: { title: '详情', permission: 'ticket/job/regular' }
                  }
                ]
              },
              {
                path: 'special',
                meta: { title: '特殊作业票' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/ticket/job/special/TicketView.vue')
                  },
                  {
                    path: 'add',
                    component: () => import('@/views/ticket/job/special/AddView.vue'),
                    meta: { title: '添加' }
                  },
                  {
                    path: 'look',
                    component: () => import('@/views/ticket/job/special/LookView.vue'),
                    meta: { title: '详情', permission: 'ticket/job/special' }
                  }
                ]
              }
            ]
          },
          {
            path: 'regular',
            meta: { title: '其他票据' },
            children: [
              {
                path: '',
                component: () => import('@/views/ticket/regular/TicketView.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/ticket/regular/AddView.vue'),
                meta: { title: '添加' }
              },
              {
                path: 'look',
                component: () => import('@/views/ticket/regular/LookView.vue'),
                meta: { title: '详情', permission: 'ticket/regular' }
              }
            ]
          },
          {
            path: 'template',
            component: () => import('@/views/ticket/template/LayoutView.vue'),
            meta: { title: '票据模板' },
            children: [
              {
                path: '',
                component: () => import('@/views/ticket/template/TemplateView.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/ticket/template/AddView.vue'),
                meta: { title: '添加' }
              },
              {
                path: 'update',
                component: () => import('@/views/ticket/template/UpdateView.vue'),
                meta: { title: '修改' }
              },
              {
                path: 'preview',
                component: () => import('@/views/ticket/template/PreviewView.vue'),
                meta: { title: '预览', permission: 'ticket/template' }
              },
              {
                path: 'shared',
                component: () => import('@/views/ticket/template/SharedView.vue'),
                meta: { title: '共享模板', permission: 'ticket/template' }
              }
            ]
          },
          {
            path: 'print',
            component: () => import('@/views/ticket/PrintView.vue'),
            meta: { title: '打印', permission: 'ticket' }
          }
        ]
      },
      {
        path: 'behavior',
        meta: { title: '行为管理', layout: true },
        children: [
          {
            path: 'violation',
            component: () => import('@/views/behavior/violation/LayoutView.vue'),
            meta: { title: '违规记录' },
            children: [
              {
                path: '',
                component: () => import('@/views/behavior/violation/ViolationView.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/behavior/violation/AddView.vue'),
                meta: { title: '违规提报', permission: 'behavior/violation/report' }
              },
              {
                path: 'update',
                component: () => import('@/views/behavior/violation/UpdateView.vue'),
                meta: { title: '重新提报', permission: 'behavior/violation/report' }
              },
              {
                path: 'look',
                component: () => import('@/views/behavior/violation/LookView.vue'),
                meta: { title: '查看', permission: 'behavior/violation' }
              },
              {
                path: 'history',
                component: () => import('@/views/behavior/violation/HistoryView.vue'),
                meta: { title: '提报历史', permission: 'behavior/violation' }
              },
              {
                path: 'regulation',
                component: () => import('@/views/behavior/violation/RegulationView.vue'),
                meta: { title: '设置违规规章', permission: 'behavior/violation/set' }
              }
            ]
          },
          {
            path: 'violationScore',
            component: () => import('@/views/behavior/violationScore/LayoutView.vue'),
            meta: { title: '违规计分' },
            children: [
              {
                path: '',
                component: () => import('@/views/behavior/violationScore/ScoreView.vue')
              },
              {
                path: 'history',
                component: () => import('@/views/behavior/violationScore/HistoryView.vue'),
                meta: { title: '计分历史', permission: 'behavior/violationScore' }
              },
              {
                path: 'train',
                component: () => import('@/views/behavior/violationScore/TrainView.vue'),
                meta: { title: '设置违规培训', permission: 'behavior/violationScore/set' }
              }
            ]
          }
        ]
      },
      {
        path: 'score',
        meta: { title: '积分管理', layout: true },
        children: [
          {
            path: 'safety',
            component: () => import('@/views/score/safety/LayoutView.vue'),
            meta: { title: '安全积分' },
            children: [
              {
                path: '',
                component: () => import('@/views/score/safety/ScoreView.vue')
              },
              {
                path: 'setting',
                component: () => import('@/views/score/safety/SettingView.vue'),
                meta: { title: '积分设置', permission: 'score/safety/saveSetting' }
              }
            ]
          },
          {
            path: 'goods',
            component: () => import('@/views/score/goods/LayoutView.vue'),
            meta: { title: '积分商品' },
            children: [
              {
                path: '',
                component: () => import('@/views/score/goods/GoodsView.vue')
              },
              {
                path: 'add',
                component: () => import('@/views/score/goods/AddView.vue'),
                meta: { title: '添加' }
              },
              {
                path: 'update',
                component: () => import('@/views/score/goods/UpdateView.vue'),
                meta: { title: '编辑' }
              },
              {
                path: 'look',
                component: () => import('@/views/score/goods/LookView.vue'),
                meta: { title: '详情', permission: 'score/goods' }
              },
              {
                path: 'history',
                component: () => import('@/views/score/goods/HistoryView.vue'),
                meta: { title: '兑换日志', permission: 'score/goods' }
              },
              {
                path: 'redeemDetail',
                component: () => import('@/views/score/goods/RedeemDetail.vue'),
                meta: { title: '兑换详情', permission: 'score/goods' }
              }
            ]
          }
        ]
      },
      {
        path: 'statistics',
        component: () => import('@/views/statistics/LayoutView.vue'),
        meta: { title: '统计分析', permission: 'statistics' },
        redirect: { path: '/statistics/overview' },
        children: [
          {
            path: 'overview',
            component: () => import('@/views/statistics/OverviewView.vue'),
            meta: { title: '概览' }
          },
          {
            path: 'risk',
            component: () => import('@/views/statistics/RiskStatsView.vue'),
            meta: { title: '风险评估' }
          },
          {
            path: 'check',
            component: () => import('@/views/statistics/CheckStatsView.vue'),
            meta: { title: '隐患排查' }
          },
          {
            path: 'hazard',
            component: () => import('@/views/statistics/HazardStatsView.vue'),
            meta: { title: '隐患发现' }
          },
          {
            path: 'train',
            component: () => import('@/views/statistics/TrainStatsView.vue'),
            meta: { title: '培训考试' }
          },
          {
            path: 'equip',
            component: () => import('@/views/statistics/EquipStatsView.vue'),
            meta: { title: '设备管理' }
          },
          {
            path: 'ticket',
            component: () => import('@/views/statistics/TicketStatsView.vue'),
            meta: { title: '作业票' }
          },
          {
            path: 'violation',
            component: () => import('@/views/statistics/ViolationStatsView.vue'),
            meta: { title: '违规计分' }
          },
          {
            path: 'safetyScore',
            component: () => import('@/views/statistics/SafetyScoreStatsView.vue'),
            meta: { title: '安全积分' }
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/LoginView.vue')
  },
  {
    path: '/error',
    component: () => import('@/views/ErrorView.vue')
  },
  {
    path: '/:pathMatch(.*)*', // 404
    component: () => import('@/views/404.vue'),
    props: (route) => ({ url: route.fullPath })
  }
]

export default routes
